<template>
    <v-app>
        <v-main class="login-bg">
            <v-container fluid class="fill-height pa-0">
                <v-row no-gutters align="center" justify="center">
                    <v-col cols="12" sm="10" md="7" lg="5">
                        <v-card class="elevation-8 rounded-xl overflow-hidden">
                            <!-- Header / Branding -->
                            <div class="brand-header py-6 px-6 d-flex align-center">
                                <v-avatar size="48" class="mr-4" v-if="logoSrc">
                                    <img :src="logoSrc" alt="IUA" />
                                </v-avatar>
                                <div>
                                    <div class="text-h6 text-sm-h5 font-weight-bold">Instituto Universitario Aeronáutico
                                    </div>
                                    <div class="subtitle-2 iua-accent">Sistema de Planificación</div>
                                </div>
                                <v-spacer></v-spacer>
                            </div>

                            <v-divider></v-divider>

                            <!-- Form -->
                            <v-card-text class="py-8 px-6 px-md-8">
                                <v-form ref="form" lazy-validation @submit.prevent="onSubmit">
                                    <v-row>
                                        <!-- DNI -->
                                        <v-col cols="12">
                                            <v-text-field v-model="dni" label="Número de documento"
                                                prepend-inner-icon="mdi-card-account-details-outline" outlined dense
                                                :rules="dniRules" inputmode="numeric" maxlength="10"
                                                autocomplete="username" @keyup.enter="onSubmit" />
                                        </v-col>

                                        <!-- Email local-part + fixed domain -->
                                        <v-col cols="12">
                                            <div class="d-flex align-end">
                                                <v-text-field v-model="emailName" label="Correo institucional"
                                                    placeholder="nombre email" prepend-inner-icon="mdi-email-outline"
                                                    outlined dense :rules="emailNameRules">
                                                    <template v-slot:append-outer>
                                                        <span class="domain-suffix">@iua.edu.ar</span>
                                                    </template>
                                                </v-text-field>
                                            </div>
                                            <small class="grey--text">Ingresá solo el nombre del correo; el dominio es
                                                fijo.</small>
                                        </v-col>
                                        <v-col cols="12" class="mt-2">
                                            <v-btn :loading="loading" :disabled="loading" color="primary" large block
                                                @click="onSubmit">
                                                Ingresar
                                            </v-btn>
                                        </v-col>
                                        <v-col cols="12" class="text-center mt-1">
                                            <span class="caption grey--text">Al continuar aceptás los términos de uso y
                                                la política de privacidad.</span>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-card-text>

                            <!-- Footer -->
                            <v-divider></v-divider>
                            <v-card-actions class="px-6 py-4">
                                <v-spacer></v-spacer>
                                <v-btn text small class="iua-accent--text" @click="$emit('help')">
                                    ¿Necesitás ayuda?
                                </v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>

            <!-- Snackbar -->
            <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3500" top>
                {{ snackbar.text }}
                <v-btn text @click="snackbar.show = false">Cerrar</v-btn>
            </v-snackbar>
        </v-main>
    </v-app>
</template>

<script>
export default {
    name: 'LoginIUA',
    props: {
        logoSrc: { type: String, default: '' }
    },
    data: () => ({
        dni: '',
        emailName: '',
        loading: false,
        snackbar: { show: false, text: '', color: 'success' },
        dniRules: [
            v => !!v || 'Ingresá tu documento',
            v => /^\d{7,10}$/.test(v) || 'Solo números (7 a 10 dígitos)'
        ],
        emailNameRules: [
            v => !!v || 'Ingresá el nombre del correo',
            v => /^[a-zA-Z0-9_.-]+$/.test(v) || 'Usá letras, números, punto, guión o guión bajo'
        ]
    }),
    computed: {
        fullEmail() {
            return this.emailName ? `${this.emailName}@iua.edu.ar` : ''
        }
    },
    methods: {
        async onSubmit() {
            const valid = this.$refs.form && this.$refs.form.validate()
            if (!valid) return

            try {
                this.loading = true
                const payload = {
                    dni: this.dni, email: this.fullEmail, username: "Dispo", password: "Dispo"
                }
                this.$auth.loginDisponibilidad(payload);
            } catch (err) {
                console.error(err)
                const msg = err?.response?.data?.message || 'No pudimos iniciar sesión. Verificá los datos.'
                this.showSnack(msg, 'error')
            } finally {
                this.loading = false
            }
        },
        showSnack(text, color = 'success') {
            this.snackbar = { show: true, text, color }
        }
    }
}
</script>

<style scoped>
/* Background with soft gradient, aligned to IUA palette (azules institucionales) */
.login-bg {
    background: linear-gradient(135deg, #0d2a4a 0%, #1a4f8b 50%, #e6eef7 100%);
    min-height: 100vh;
}

.brand-header {
    background: #f7fbff;
}

.iua-accent {
    color: #1a4f8b;
}

.iua-accent--text {
    color: #1a4f8b !important;
}

.iua-domain {
    border: 1px dashed #0d2a4a33;
}

/* Card responsiveness and elevation feel */
.v-card {
    backdrop-filter: saturate(1.05) blur(2px);
}

/* Small tweaks for compact look on mobile */
.v-text-field>>>.v-label {
    opacity: 0.9;
}
</style>
